import Marquee from "react-fast-marquee";
import { Wheat } from "lucide-react";

const ITEMS = [
  "Lievitazione 24/48h",
  "Farine Siciliane",
  "Russello · Timilia · Perciasacchi",
  "Aperti 7/7 a cena",
  "Consegna a Domicilio",
  "Pane Condito",
  "Fiumefreddo di Sicilia",
];

export default function MarqueeBand() {
  return (
    <div data-testid="marquee-band" className="border-y border-white/10 py-8 sm:py-10 bg-ink relative z-10">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display italic text-3xl sm:text-5xl text-cream/75 mx-10 sm:mx-16 whitespace-nowrap">
              {t}
            </span>
            <Wheat size={22} strokeWidth={1.2} className="text-terra shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
